module.exports = __webpack_public_path__ + "static/img/tiktok.ad5cd59b.svg";